import { ROUTE_UI_SECTION_NAME } from '../constants/route'

import { useInitData } from './useInitData'

export function useIsBuildingGroupProfileNGAvailable() {
  const { availableSections } = useInitData()

  return !!availableSections?.[ROUTE_UI_SECTION_NAME.buildingGroupProfileDetail]
}
